import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, FileText } from "lucide-react";
import { ProposalDocument, ProposalToolbar } from "@/components/proposal/ProposalDocument";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STATUS_LABEL = {
  DRAFT: "Draft", SENT: "Sent", VIEWED: "Viewed", ACCEPTED: "Accepted", DECLINED: "Declined", EXPIRED: "Expired",
};

export default function PublicProposal() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/public/proposals/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.status === 404 ? "This proposal link is not valid." : "Unable to load this proposal."));
  }, [token]);

  return (
    <div className="min-h-screen bg-background px-4 py-10 print:bg-white print:p-0" data-testid="public-proposal-page">
      <div className="mx-auto max-w-4xl">
        {error && (
          <div className="rounded-md border border-border bg-white p-10 text-center" data-testid="public-proposal-error">
            <FileText className="mx-auto h-8 w-8 text-muted-foreground" />
            <p className="mt-4 text-sm text-warmgrey">{error}</p>
          </div>
        )}
        {!error && !data && (
          <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-terracotta" /></div>
        )}
        {data && (
          <div data-testid="public-proposal-card">
            <ProposalToolbar pdfUrl={`${API}/public/proposals/${token}/pdf`} />
            {data.status === "EXPIRED" && (
              <p className="mb-4 rounded-md bg-sand p-3 text-sm text-[#8a6435]" data-testid="public-proposal-expired">
                This proposal has expired — please contact {data.dealer_name} for an updated quote.
              </p>
            )}
            <ProposalDocument data={data} logoUrl={`${API}/public/proposals/${token}/logo`} />
            <p className="print:hidden mt-3 text-center text-[10px] uppercase tracking-[0.2em] text-muted-foreground" data-testid="public-proposal-status">
              Status: {STATUS_LABEL[data.status] || data.status}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
